import Vue from 'vue'
import Router from 'vue-router'

const home = () => import('views/home/home.vue');
const search = () => import('views/home/search/search.vue');
const guide = () => import('views/home/guide/guide.vue');
const login = () => import('views/account/login/login.vue');
const loginForA = () => import('views/account/login/loginForA.vue');
const findPwd = () => import('views/account/findPwd/findPwd.vue');

const why = () => import('views/home/help/why.vue');
const know = () => import('views/home/help/know.vue');
const power = () => import('views/home/help/power.vue');

const layout = () => import('components/layout/layout.vue');

const caselist = () => import('src/views/caselist/caselist.vue');
const caselinelist = () => import('src/views/caselist/caselinelist.vue');
const caselistForA = () => import('views/caselist/caselistForA.vue');

const details = () => import('views/caseDetails/caseDetails.vue');
const caselineDetail = () => import('views/caseDetails/caselineDetail/caselineDetail.vue');

// 操作界面
const pay = () => import('views/action/pay/pay.vue');
const wxpay = () => import('views/action/pay/wxpay.vue');
const ylpay = () => import('views/action/pay/wxpay.vue');
const success = () => import('views/action/pay/success.vue');
const proof = () => import('views/action/proof/proof.vue');
const otherSubmit = () => import('views/action/otherSubmit/otherSubmit.vue');
const editOtherSubmit = () => import('views/action/otherSubmit/editSubmit.vue');
const examination = () => import('views/action/examination/examination.vue');
const question = () => import('views/action/question/question.vue');
const answer = () => import('views/action/answer/answer.vue');
const draft = () => import('views/action/draft/draft.vue');
const replyList = () => import('views/action/reply/replyList.vue');
const reply = () => import('views/action/reply/reply.vue');
const replyShow = () => import('views/action/reply/replyShow.vue');
const letterView = () => import('views/action/letter/letterView.vue');
const suggest = () => import('views/action/suggest/suggest.vue');

// 注册
const register = () => import('views/account/register');

const phoneLayout = () => import('components/layout/phone');
const phone = () => import('views/phone');
const face = () => import('views/phone/face');
const idCard = () => import('views/phone/idCard');
const confirm = () => import('views/phone/idCard/confirm');
const realSuccess = () => import('views/phone/face/success');
//  站内信
const message = () => import('views/message');
//  留言板
const tips = () => import('views/tips');
// 发起仲裁
const addCaseList = () => import('views/addCase/addCase.vue');
// 个人中心
const personalCenter = () => import('views/personalCenter/personal-center.vue');
// 送达
const sendLogin = () => import('views/account/login/sendLogin.vue');
const caseMail = () => import('views/delivery/mail.vue');
const caseMessage = () => import('views/delivery/message.vue');
const deliveryMail = () => import('views/delivery/detail');


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/login',
      meta: {
        isStatic: true
      },
      name: 'login',
      component: login
    },
    {
      path: '/arbitor/login',
      meta: {
        isStatic: true
      },
      name: 'loginForA',
      component: loginForA
    },
    {
      path: '/sendLogin',
      meta: {
        isStatic: true
      },
      name: 'sendLogin',
      component: sendLogin
    },
    {
      path: '/register',
      meta: {
        isStatic: true
      },
      name: 'register',
      component: register
    },
    {
      path: '/phoneLayout',
      component: phoneLayout,
      redirect: '/phone',
      children: [
        {
          path: '/phone',
          name: 'phone',
          meta: {
            isStatic: true
          },
          component: phone,
        },
        {
          path: '/phone/face',
          name: 'face',
          meta: {
            isStatic: true
          },
          component: face,
        },
        {
          path: '/phone/idCard',
          name: 'idCard',
          meta: {
            isStatic: true
          },
          component: idCard,
        },
        {
          path: '/phone/idCard/confirm',
          name: 'confirm',
          meta: {
            isStatic: true
          },
          component: confirm,
        },
        {
          path: '/phone/success',
          name: 'success',
          meta: {
            isStatic: true
          },
          component: realSuccess,
        }
      ]
    },
    {
      path: '/layout',
      component: layout,
      redirect: '/home',
      children: [
        {
          path: '/personalCenter',
          meta: {
            isStatic: true
          },
          component: personalCenter
        },
        {
          path: '/findPwd',
          meta: {
            isStatic: true
          },
          component: findPwd
        },
        {
          path: '/addCase',
          name: 'addCaseList',
          meta: {
            type: 'party'
          },
          component: addCaseList,
        },
        {
          path: '/arbitor/findPwd',
          meta: {
            isStatic: true
          },
          component: findPwd
        },
        {
          path: '/home',
          meta: {
            isStatic: true
          },
          component: home
        },
        {
          path: '/search',
          meta: {
            isStatic: true
          },
          component: search
        },
        {
          path: '/guide',
          meta: {
            isStatic: true
          },
          name: 'guide',
          component: guide
        },
        {
          path: '/guide/why',
          meta: {
            isStatic: true
          },
          name: 'why',
          component: why
        },
        {
          path: '/guide/know',
          meta: {
            isStatic: true
          },
          name: 'know',
          component: know
        },
        {
          path: '/guide/power',
          meta: {
            isStatic: true
          },
          name: 'power',
          component: power
        },
        {
          path: '/caselinelist',
          component: caselinelist
        },
        {
          path: '/caselineDetail',
          component: caselineDetail
        },
        {
          path: '/caselist',
          component: caselist
        },
        {
          path: '/arbitor/caselist',
          component: caselistForA
        },
        {
          path: '/caselist/details',
          name: 'details',
          component: details
        },
        {
          path: '/caselist/letterView',
          name: 'letterView',
          component: letterView
        },
        {
          path: '/caselist/pay',
          name: 'pay',
          component: pay
        },
        {
          path: '/caselist/pay/success',
          name: 'success',
          component: success
        },
        {
          path: '/caselist/pay/wxpay',
          name: 'wxpay',
          component: wxpay
        },
        {
          path: '/caselist/proof',
          name: 'proof',
          component: proof
        },
        {
          path: '/suggest/suggest',
          name: 'suggest',
          component: suggest
        },

        {
          path: '/caselist/otherSubmit',
          name: 'otherSubmit',
          component: otherSubmit
        },
        {
          path: '/caselist/otherSubmit/add',
          name: 'addOtherSubmit',
          component: editOtherSubmit
        },
        {
          path: '/caselist/otherSubmit/edit/:id',
          name: 'editOtherSubmit',
          component: editOtherSubmit
        },
        {
          path: '/caselist/otherSubmit/view/:id',
          name: 'viewOtherSubmit',
          component: editOtherSubmit
        },
        {
          path: '/caselist/examination',
          name: 'examination',
          component: examination
        },
        {
          path: '/caselist/question',
          name: 'question',
          component: question
        },
        {
          path: '/caselist/answer',
          name: 'answer',
          component: answer
        },
        {
          path: '/caselist/draft',
          name: 'draft',
          component: draft
        },
        {
          path: '/caselist/draft/edit',
          name: 'editDraft',
          component: draft
        },
        {
          path: '/caselist/draft/signet',
          name: 'signetDraft',
          component: draft
        },
        {
          path: '/caselist/replyList',
          name: 'replyList',
          component: replyList
        },
        {
          path: '/caselist/replyList/reply',
          name: 'reply',
          component: reply
        },
        {
          path: '/caselist/replyList/show',
          name: 'replyShow',
          component: replyShow
        },
        {
          path: '/message',
          name: 'message',
          component: message
        },
        {
          path: '/tips',
          name: 'tips',
          component: tips
        },
        //送达
        {
          path: '/send/caseMail',
          name: 'caseMail',
          meta: {
            keepAlive: true
          },
          component: caseMail
        },
        {
          path: '/send/caseMessage',
          name: 'caseMessage',
          meta: {
            keepAlive: true
          },
          component: caseMessage
        },
        {
          path: '/deliveryCase/deliveryMail',
          name: 'deliveryMail',
          component: deliveryMail
        },
      ]
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js